import baseMapProductIds from '../../base/baseMapProductIds'
import useProductSettings from '../../base/baseMapProductSettings'
import baseParameterIds from '../../base/baseParameterIds'

export default () => {
  const PARAM_IDS = baseParameterIds
  const DEFAULT_PRODUCT_SETTINGS = useProductSettings(PARAM_IDS)
  const PRODUCT_IDS = baseMapProductIds
  const newProductSettings = {}

  // Wind map product settings
  const windMapSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.WIND]
  windMapSettings.overlays.markers.loc = [1]

  newProductSettings[PRODUCT_IDS.WIND] = windMapSettings

  // Change combined model runs to false for forecast layers
  const windForecastSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.FORECAST]
  const temperatureForecastSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.TEMPERATURE_FORECAST]
  const pressureForecastSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.PRESSURE_FORECAST]
  const humidityForecastSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.HUMIDITY_FORECAST]

  windForecastSettings.overlays.fx.combineModelRuns = false
  temperatureForecastSettings.overlays.fx.combineModelRuns = false
  pressureForecastSettings.overlays.fx.combineModelRuns = false
  humidityForecastSettings.overlays.fx.combineModelRuns = false

  newProductSettings[PRODUCT_IDS.FORECAST] = windForecastSettings
  newProductSettings[PRODUCT_IDS.TEMPERATURE_FORECAST] = temperatureForecastSettings
  newProductSettings[PRODUCT_IDS.PRESSURE_FORECAST] = pressureForecastSettings
  newProductSettings[PRODUCT_IDS.HUMIDITY_FORECAST] = humidityForecastSettings

  // Nowcast map product settings
  const nowcastSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.NOWCAST]
  nowcastSettings.overlays.markers.data = [100]
  nowcastSettings.overlays.markers.loc = [100, 1]

  newProductSettings[PRODUCT_IDS.NOWCAST] = nowcastSettings

  // Add coastal outlines to radar & satellite map layers
  const radarSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.RADAR]
  const satelliteSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.SATELLITE]

  radarSettings.overlays.coastal_outline = {}
  satelliteSettings.overlays.coastal_outline = {}

  newProductSettings[PRODUCT_IDS.RADAR] = radarSettings
  newProductSettings[PRODUCT_IDS.SATELLITE] = satelliteSettings

  // Radar + wind map product settings
  const radarWindSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.RADAR_WIND]
  radarWindSettings.overlays.markers.loc = []
  radarWindSettings.overlays.coastal_outline = {}

  newProductSettings[PRODUCT_IDS.RADAR_WIND] = radarWindSettings

  // Satellite + wind map product settings
  const satelliteWindSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.SATELLITE_WIND]
  satelliteWindSettings.overlays.markers.loc = []
  satelliteWindSettings.overlays.coastal_outline = {}

  newProductSettings[PRODUCT_IDS.SATELLITE_WIND] = satelliteWindSettings

  newProductSettings[PRODUCT_IDS.RADAR_WIND] = radarWindSettings

  return Object.assign({}, DEFAULT_PRODUCT_SETTINGS, newProductSettings)
}